import React from 'react'
import styles from './A23AutoActionButton.module.css'
import { ALL_IN_ACTION, AUTO_CALL_ACTION, AUTO_CALL_ANY_ACTION, AUTO_CHECK_ACTION, AUTO_CHECK_OR_FOLD_ACTION, AUTO_FOLD_ACTION, RUPEE_SYMBOL } from '@/Poker/data/Constants'
import useGameSocket from '@/src/hooks/utils/useGameSocket';
import { FaCheck } from "react-icons/fa";
import { AnimatePresence, LayoutGroup, motion } from 'motion/react';

export default function AutoActionButton({ tempTableId, action, callAmount, raiseAmount, allInForCall, active, label }) {
    const {
        sendAutoActionProtocol
    } = useGameSocket(tempTableId);

    const handleAutoActionButton = () => {
        sendAutoActionProtocol(action, !active)
    }

    return (
        <motion.div layout={true} onClick={handleAutoActionButton} className={`${styles.autoActionButton} ${active ? styles.activeAutoActionButton : ''}`}>
            <LayoutGroup>
                <AnimatePresence>
                    {
                        active ? (
                            <motion.div
                                layout={true}
                                initial={{ opacity: 0, scale: 0 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0 }}
                                transition={{ duration: 0.2 }}
                            >
                                <FaCheck
                                    style={{
                                        filter: active ? 'drop-shadow(0 0px 5px var(--color-accent-theme))' : 'drop-shadow(0 0px 10px var(--color-secondary))'
                                    }}
                                    size={12} color={active ? 'var(--color-focus)' : 'var(--color-secondary)'} />
                            </motion.div>
                        )
                            : null
                    }
                </AnimatePresence>
                <motion.div layout={true} className={styles.autoActionButtonLabel}>{label ? label : action}{callAmount ? ` ${RUPEE_SYMBOL + callAmount}` : ''}</motion.div>
            </LayoutGroup>
        </motion.div>
    )
}
